import deepmerge from 'deepmerge'
import defaultConfig from './defaultConfig'
import generateModal, { setFocusEvents } from './generateModal'
import { setCookie, getCookie, removeCookie } from './cookies'
import './scss/main.scss'

const MODAL_ID = 'cctr-js-modal'
const MODAL_TOGGLE_ID = 'cctr-js-modal-toggle'

const state = {
  isOpen: true,
  config: null,
  options: [],
  hasActed: false,
  previousFocus: null,
}

const setState = ( key, value, updateDOM = true ) => {
  state[ key ] = value

  if ( updateDOM && state.config ) {
    update( state )
  }
}

export const getState = () => state

export const openModal = () => {
  setState( 'previousFocus', document.activeElement, false )
  setState( 'isOpen', true )
}

const closeModal = () => {
  setState( 'isOpen', false )
}

const saveAndCloseModal = () => {
  setCookie( state.config.cookieName, state.options, 1000 )
  setState( 'hasActed', true )
  fireOnUserSettings()
  closeModal()
}

const fireOnUserSettings = () => {
  if ( state.config && state.config.onUserSettings ) {
    state.config.onUserSettings( {
      options: state.options,
      hasActed: state.hasActed,
    } )
  }
}

const update = ( state ) => {
  replaceModal( state )
}

const replaceModal = ( state ) => {
  // if ( !document.getElementById( MODAL_TOGGLE_ID ) ) {
  //   const modalToggleBtn = modalToggleButton( toggleModal )
  //   document.body.appendChild( modalToggleBtn )
  //   modalToggleBtn.id = MODAL_TOGGLE_ID
  // }

  const oldModal = document.getElementById( MODAL_ID )

  if ( state.isOpen ) {
    const newModal = generateModal( {
      state,
      setState,
      saveAndCloseModal,
    } )

    if ( oldModal ) {
      oldModal.parentNode.replaceChild( newModal, oldModal )
    }
    else {
      document.body.appendChild( newModal )
    }

    newModal.id = MODAL_ID
    document.body.style.height = '100vh'
    document.body.style.overflowY = 'hidden'
    setFocusEvents( newModal, state, setState )
  }
  else if ( oldModal ) {
    oldModal.parentNode.removeChild( oldModal )
    document.body.style.height = ''
    document.body.style.overflowY = ''

    if ( state.previousFocus ) {
      state.previousFocus.focus()
    }
  }
}

export const init = ( config ) => {
  let cfg = deepmerge( defaultConfig, config )
  const cookie = getCookie( cfg.cookieName )
  const optionsState = {}

  cfg.options.map( option => {
    optionsState[ option.name ] = (
      cookie && typeof cookie[ option.name ] !== 'undefined'
    )
      ? cookie[ option.name ]
      : option.defaultChecked || false
  } )

  setState( 'hasActed', !!cookie )
  setState( 'isOpen', !cookie )
  setState( 'options', optionsState )
  setState( 'config', cfg )
  fireOnUserSettings()
  update( state )
}

export const removeCookies = ( names, { domain, path } ) => {
  names.forEach( name => removeCookie( name, { domain, path } ) )
}